export default __webpack_public_path__ + "static/media/bonusWin.d3052e81.mp3";